module.exports = __webpack_public_path__ + "static/media/laptop-photo.4904ec29.png";